"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../utils");

var _TeamMemberItem = _interopRequireDefault(require("../../TeamMemberItem"));

var _AddUserToTeam = _interopRequireDefault(require("./AddUserToTeam"));

var _InviteUsersToTeam = _interopRequireDefault(require("./InviteUsersToTeam"));

require("../styles/_assign-user.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INITIAL_STATE = {
  users: [],
  assignedUsers: [],
  searchTerm: '',
  team: void 0
};

var Subtitle = function Subtitle(_ref) {
  var orgName = _ref.orgName,
      teamName = _ref.teamName;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Select Users within", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 'bold',
      margin: '0 4px'
    }
  }, orgName), "to join the", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 'bold',
      margin: '0 4px'
    }
  }, teamName), "team");
};

var AssignUserModal = /*#__PURE__*/function (_Component) {
  _inherits(AssignUserModal, _Component);

  var _super = _createSuper(AssignUserModal);

  function AssignUserModal() {
    var _this;

    _classCallCheck(this, AssignUserModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "roleOptions", (0, _lodash2.default)(function (teamRoles) {
      return function () {
        return teamRoles.map(function (_ref2) {
          var roleId = _ref2.roleId,
              name = _ref2.name;
          return {
            value: roleId,
            label: (0, _utils.formatTeamRole)(name)
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleUserAdd", (0, _lodash2.default)(function (user, teamRoleOptions) {
      return function () {
        var assignedUsers = _this.state.assignedUsers;
        var newTeamMember = {
          user: user,
          role: teamRoleOptions[1],
          updated: true
        };

        _this.setState({
          assignedUsers: [].concat(_toConsumableArray(assignedUsers), [newTeamMember])
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "clearState", function () {
      _this.setState(INITIAL_STATE);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchTeam", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getTeam, teamId, _yield$getTeam, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getTeam = _this$props.getTeam, teamId = _this$props.teamId;

              if (teamId) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return getTeam(teamId);

            case 5:
              _yield$getTeam = _context.sent;
              data = _yield$getTeam.data;
              error = _yield$getTeam.error;

              if (!(error || !data.getTeam)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              _this.setState({
                team: data.getTeam
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "searchUsers", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
        var searchOrgMemberships, _yield$searchOrgMembe, data, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                searchOrgMemberships = _this.props.searchOrgMemberships;

                _this.setState({
                  searchTerm: value
                });

                _context2.next = 4;
                return searchOrgMemberships({
                  searchTerm: value.toLowerCase(),
                  limit: (0, _lodash.default)(value) ? 10 : void 0
                });

              case 4:
                _yield$searchOrgMembe = _context2.sent;
                data = _yield$searchOrgMembe.data;
                error = _yield$searchOrgMembe.error;

                if (!(error || !data || !data.searchOrgMemberships)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                _this.setState({
                  users: data.searchOrgMemberships.map(function (_ref5) {
                    var user = _ref5.user;
                    return user;
                  })
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleModalSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props2, updateTeamMemberships, onClose, teamId, onSave, assignedUsers, membersToUpdate, _yield$updateTeamMemb, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props2 = _this.props, updateTeamMemberships = _this$props2.updateTeamMemberships, onClose = _this$props2.onClose, teamId = _this$props2.teamId, onSave = _this$props2.onSave;
              assignedUsers = _this.state.assignedUsers;

              if (!(0, _lodash.default)(assignedUsers)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              membersToUpdate = assignedUsers.map(function (assignedUser) {
                return {
                  userId: assignedUser.user.userId,
                  roleId: assignedUser.role.value
                };
              });
              _context3.next = 7;
              return updateTeamMemberships({
                members: membersToUpdate,
                teamId: teamId
              });

            case 7:
              _yield$updateTeamMemb = _context3.sent;
              error = _yield$updateTeamMemb.error;

              if (!error) {
                onSave();
                onClose();
              }

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "onRoleSelectClose", function (userId) {
      var assignedUsers = _this.state.assignedUsers;
      var updatedAssignedUsers = assignedUsers.filter(function (assignedUser) {
        return assignedUser.user.userId !== userId;
      });

      _this.setState({
        assignedUsers: updatedAssignedUsers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectTeamRole", function (userId, role) {
      var assignedUsers = _this.state.assignedUsers;

      if (assignedUsers.length === 0) {
        return;
      }

      var updatedAssignedUsers = assignedUsers.map(function (assignedUser) {
        if (assignedUser.user.userId === userId) {
          return _objectSpread(_objectSpread({}, assignedUser), {}, {
            role: role
          });
        }

        return _objectSpread({}, assignedUser);
      });

      _this.setState({
        assignedUsers: updatedAssignedUsers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInviteUserToTeam", function () {
      var _this$props3 = _this.props,
          onInviteUserToTeam = _this$props3.onInviteUserToTeam,
          onClose = _this$props3.onClose;
      onClose();
      onInviteUserToTeam();
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearchUsers", function () {
      var _this$state = _this.state,
          members = _this$state.team.members,
          users = _this$state.users,
          assignedUsers = _this$state.assignedUsers;
      var _this$props4 = _this.props,
          teamRoles = _this$props4.teamRoles,
          hasManagePermission = _this$props4.hasManagePermission;
      var removePendingUser = users.filter(function (user) {
        return user;
      });
      var teamUsers = members.map(function (_ref7) {
        var user = _ref7.user;
        return user.userId;
      });
      var filteredUsers = removePendingUser.filter(function (user) {
        return !teamUsers.includes(user.userId) && Object.values(user);
      });

      var teamRoleOptions = _this.roleOptions(teamRoles)();

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, filteredUsers.map(function (user) {
        var userFound = assignedUsers.find(function (addedUser) {
          return addedUser.user.userId === user.userId;
        });
        return /*#__PURE__*/_react.default.createElement(_TeamMemberItem.default, {
          key: user.userId,
          user: user,
          showTitle: true,
          additionalContent: /*#__PURE__*/_react.default.createElement(_AddUserToTeam.default, {
            hasManagePermission: hasManagePermission,
            userFound: userFound,
            onSelectTeamRole: function onSelectTeamRole(role) {
              return _this.onSelectTeamRole(userFound.user.userId, role);
            },
            teamRoleOptions: teamRoleOptions,
            onUserAdd: _this.handleUserAdd(user, teamRoleOptions),
            onClose: function onClose() {
              return _this.onRoleSelectClose(userFound.user.userId);
            }
          })
        });
      }), /*#__PURE__*/_react.default.createElement(_InviteUsersToTeam.default, {
        onInviteUser: _this.onInviteUserToTeam
      }));
    });

    _this.state = INITIAL_STATE;
    return _this;
  }

  _createClass(AssignUserModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fetchTeam();

              case 2:
                _context4.next = 4;
                return this.searchUsers('');

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref8) {
      var prevVisible = _ref8.visible;
      var visible = this.props.visible;
      var isModalOpening = visible && !prevVisible;

      if (!isModalOpening) {
        return;
      }

      this.clearState();
      this.fetchTeam();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          visible = _this$props5.visible,
          onClose = _this$props5.onClose,
          teamId = _this$props5.teamId,
          hasManagePermission = _this$props5.hasManagePermission,
          orgName = _this$props5.orgName;
      var _this$state2 = this.state,
          team = _this$state2.team,
          searchTerm = _this$state2.searchTerm,
          assignedUsers = _this$state2.assignedUsers;

      if (!team) {
        return null;
      }

      var saveDisabled = !hasManagePermission || assignedUsers.length === 0;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "assign-user"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: onClose,
        key: "assign-user-modal",
        title: "Add Users",
        subtitle: /*#__PURE__*/_react.default.createElement(Subtitle, {
          orgName: orgName,
          teamName: team.name
        }),
        onSave: this.handleModalSave,
        saveText: "Save Changes",
        saveDisabled: saveDisabled
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        key: "users-search",
        placeholder: "Search",
        defaultValue: searchTerm,
        onChange: function onChange(e) {
          return _this2.searchUsers(e.target.value);
        },
        prefix: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "search",
          size: 25,
          color: "black"
        }),
        clearButton: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "close",
          size: 10,
          color: "regent"
        })
      }), /*#__PURE__*/_react.default.createElement("div", {
        key: teamId,
        className: "assign-user__team"
      }, this.renderSearchUsers())));
    }
  }]);

  return AssignUserModal;
}(_react.Component);

var _default = AssignUserModal;
exports.default = _default;